/* eslint-disable consistent-return */
/* eslint-disable default-case */
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import { Box, Link, Typography, makeStyles } from '@material-ui/core';
import { Done, HourglassEmpty, BlockOutlined, CardMembership } from '@material-ui/icons';
import { useCallback } from 'react';
import moment from 'moment';
import { colours } from '../constants/theme';
import { useTranslation } from 'react-i18next';

interface ICollectionDashboardItemProps {
  title: string;
  count: number;
}

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: colours.highEmphasis,
    color: colours.primary,
    padding: 16,
    borderRadius: 8,
    textAlign: 'left',
    position: 'relative'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 16
  },
  icon: {
    marginTop: 4
  },
  count: {
    color: colours.lightEmphasis
  },
  description: {
    color: colours.lightEmphasis
  },
  link: {
    flex: 1,
    textDecoration: 'none !important'
  },
  openInNew: {
    fontSize: 14
  },
  cardIcon: {
    '& > svg': {
      fontSize: 70,
      color: colours.lightEmphasis,
      opacity: 0.54
    },
    position: 'absolute',
    bottom: 8,
    right: 16
  },
  ctaContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    gap: 8
  }
}));

export default function CollectionDashboardItem(props: ICollectionDashboardItemProps) {
  const { title, count } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const getIcon = () => {
    // Handle both hardcoded strings and translation keys
    if (title === 'Open' || (title.includes('Open') && !title.includes('Concierge'))) {
      return HourglassEmpty;
    }
    if (title === 'Open Concierge Orders' || title.includes('Concierge')) {
      return CardMembership;
    }
    if (title === 'In Transit' || title.includes('Transit')) {
      return LocalShippingOutlinedIcon;
    }
    if (title === 'Delivered' || title.includes('Delivered')) {
      return Done;
    }
    if (title === 'Failed' || title.includes('Failed')) {
      return BlockOutlined;
    }
    // Default fallback
    return HourglassEmpty;
  };


  const getUrl = useCallback(() => {
    const baseUrl = `/delivery-orders?from=dashboard&startCollectionDate=${moment()
      .startOf('day')
      .toISOString()}&endCollectionDate=${moment()
      .endOf('day')
      .toISOString()}`;
    
    // Handle both hardcoded strings and translation keys
    if (title === 'Open' || (title.includes('Open') && !title.includes('Concierge'))) {
      return `${baseUrl}&tabIndex=0`;
    }
    if (title === 'Open Concierge Orders' || title.includes('Concierge')) {
      return `${baseUrl}&tabIndex=0&conciergeOnly=true`;
    }
    if (title === 'In Transit' || title.includes('Transit')) {
      return `${baseUrl}&tabIndex=1`;
    }
    if (title === 'Failed' || title.includes('Failed')) {
      return `${baseUrl}&tabIndex=2&status=Failed`;
    }
    if (title === 'Delivered' || title.includes('Delivered')) {
      return `${baseUrl}&tabIndex=3&status=Delivered`;
    }
    // Default fallback
    return `${baseUrl}&tabIndex=0`;
  }, [title]);

  const Icon: any = getIcon();
  return (
    <Link href={getUrl()} className={classes.link}>
      <Box className={classes.container}>
        <Box>
          <Typography variant="h6">{title}</Typography>
        </Box>

        <Typography variant="h2" className={classes.count}>
          {count || 0}
        </Typography>
        <Box className={classes.ctaContainer}>
          <Typography variant="body2">{t('collectionDashboard.viewMore')}</Typography>
          <OpenInNewIcon className={classes.openInNew} />
        </Box>

        <Box className={classes.cardIcon}>
          <Icon />
        </Box>
      </Box>
    </Link>
  );
}
